<template>
  <div
    class="total"
    :value="value"
  >
    <div class="weui-cells">
      <div
        class="weui-cell"
        @click="popupChoose=true"
      >
        <div class="weui-cell__hd">
          <label
            for=""
            class="weui-label"
          >使用地/国家</label>
        </div>
        <div class="weui-cell__bd">
          {{ country }}
        </div>
      </div>
      <div class="weui-cell weui-cell_select weui-cell_select-after">
        <div class="weui-cell__hd">
          <label
            for=""
            class="weui-label"
          >译文</label>
        </div>
        <div class="weui-cell__bd">
          <select
            v-model="yiwen"
            class="weui-select"
            @click="check"
          >
            <option
              value=""
              disabled=""
              selected=""
            >
              请选择
            </option>
            <option
              v-for="(item, index) in yiwenlist"
              :key="'key-'+index"
              :value="item"
            >
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- <van-popup
      v-model="popupChoose"
      position="right"
      :overlay="true"
      class="popup-country"
    >
      <div class="main-page">
        <van-nav-bar
          title="请选择使用地"
          left-text="关闭"
          left-arrow
          @click-left="popupChoose=false"
        />
        <div class="container-flex bg--gray">
          <ul class="com-tabs">
            <li
              class="com-tab"
              :class="{'on': group === 'hot'}"
              @click="setGroup('hot')"
            >
              常用
            </li>
            <li
              class="com-tab"
              :class="{'on': group === '1'}"
              @click="setGroup('1')"
            >
              ABCDEFGH
            </li>
            <li
              class="com-tab"
              :class="{'on': group === '2'}"
              @click="setGroup('2')"
            >
              IJKLMNOP
            </li>
            <li
              class="com-tab"
              :class="{'on': group === '3'}"
              @click="setGroup('3')"
            >
              QRSTUVWXYZ
            </li>
          </ul>
          <div class="container-flex_content com-country-box">
            <div class="com-content">
              <div class="countrylist com-tabs-items">
                <div
                  v-if="group === 'hot'"
                  class="hot country item"
                >
                  <dl
                    v-for="(letter, letterindex) in grouphot"
                    :key="'key-' + letterindex"
                  >
                    <dt>
                      {{ letter }}
                    </dt>
                    <dd>
                      <template v-for="(item, index) in countrylist">
                        <a
                          v-if="item[1].toUpperCase()===letter"
                          :key="'key-' + index"
                          href="javascript:;"
                          @click="setCountry(item[0])"
                        >{{ item[0] }}</a>
                      </template>
                    </dd>
                  </dl>
                </div>
                <div
                  v-if="group === '1'"
                  class="countrygroup1 item"
                >
                  <dl
                    v-for="(letter, letterindex) in group1"
                    :key="'key-' + letterindex"
                  >
                    <dt>
                      {{ letter }}
                    </dt>
                    <dd>
                      <template v-for="(item, index) in countrylist">
                        <a
                          v-if="item[1].toUpperCase()===letter"
                          :key="'key-' + index"
                          href="javascript:;"
                          @click="setCountry(item[0])"
                        >{{ item[0] }}</a>
                      </template>
                    </dd>
                  </dl>
                </div>
                <div
                  v-if="group === '2'"
                  class="countrygroup2 item"
                >
                  <dl
                    v-for="(letter, letterindex) in group2"
                    :key="'key-' + letterindex"
                  >
                    <dt>
                      {{ letter }}
                    </dt>
                    <dd>
                      <template v-for="(item, index) in countrylist">
                        <a
                          v-if="item[1].toUpperCase()===letter"
                          :key="'key-' + index"
                          href="javascript:;"
                          @click="setCountry(item[0])"
                        >{{ item[0] }}</a>
                      </template>
                    </dd>
                  </dl>
                </div>
                <div
                  v-if="group === '3'"
                  class="countrygroup3 item"
                >
                  <dl
                    v-for="(letter, letterindex) in group3"
                    :key="'key-' + letterindex"
                  >
                    <dt>
                      {{ letter }}
                    </dt>
                    <dd>
                      <template v-for="(item, index) in countrylist">
                        <a
                          v-if="item[1].toUpperCase()===letter"
                          :key="'key-' + index"
                          href="javascript:;"
                          @click="setCountry(item[0])"
                        >{{ item[0] }}</a>
                      </template>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>
<script>
export default {
  props: ['value'],
  data () {
    return {
      popupChoose: false,
      countryHotArr:
        '美国|m|m,加拿大|j|j,日本|r|r,英国|y|y,新加坡|x|x,西班牙|x|x,意大利|y|y,澳大利亚|a|a,德国|d|d,新西兰|x|x,法国|f|f,中国澳门|z|z,中国台湾|z|z,中国香港|z|z',
      countryArr:
        '美国|m|m,加拿大|j|j,扎伊尔|z|z,莱索托|l|l,几内亚|j|j,安哥拉|a|a,尼加拉瓜|n|n,南非|n|n,阿尔巴尼亚|a|a,阿富汗|a|a,阿鲁巴|a|a,阿曼|a|a,日本|r|r,阿塞拜疆|a|a,埃塞俄比亚|a|a,爱沙尼亚|a|a,安道尔|a|a,安提瓜和巴布达|a|a,巴巴多斯|b|b,巴布亚新几内亚|b|b,巴哈马|b|b,巴林|b|b,百慕大|b|b,泰国|t|t,贝宁|b|b,波多黎各|b|b,波黑|b|b,博茨瓦纳|b|b,不丹|b|b,布其纳法索|b|b,布维岛|b|b,朝鲜|c|c,赤道几内亚|c|c,东帝汶|d|d,缅甸|m|m,多明哥|d|d,俄罗斯联邦|e|e,法罗群岛|f|f,法属玻里尼西亚|f|f,法属圭亚那|f|f,法属南方领土|f|f,梵蒂冈|f|f,斐济|f|f,佛得角|f|f,福克兰群岛|f|f,伊朗|y|y,冈比亚|g|g,刚果|g|g,格林纳达|g|g,格陵兰|g|g,格鲁吉亚|g|g,古巴|g|g,瓜德罗普|g|g,关岛|g|g,圭亚那|g|g,海地|h|h,印度|y|y,洪都拉斯|h|h,基里巴斯|j|j,吉布提|j|j,吉尔吉斯斯坦|j|j,几内亚比绍|j|j,加蓬|j|j,柬埔寨|j|j,津巴布韦|j|j,喀麦隆|k|k,约旦|y|y,开曼群岛|k|k,科摩罗|k|k,科特迪瓦|k|k,可可岛|k|k,克罗地亚|k|k,库克群岛|k|k,拉脱维亚|l|l,老挝|l|l,黎巴嫩|l|l,立陶宛|l|l,印尼|y|y,利比里亚|l|l,列支敦士登|l|l,马达加斯加|m|m,马尔他|m|m,马拉维|m|m,马绍尔群岛|m|m,毛里求斯|m|m,毛里塔尼亚|m|m,蒙古|m|m,密克罗尼西亚|m|m,韩国|h|h,摩尔多瓦|m|m,摩纳哥|m|m,莫桑比克|m|m,纳米比亚|n|n,南极洲|n|n,南斯拉夫|n|n,瑙鲁|n|n,尼日尔|n|n,纽埃|n|n,皮特开恩群岛|p|p,英国|y|y,孟加拉|m|m,萨尔瓦多|s|s,塞拉利昂|s|s,塞内加尔|s|s,塞舌尔|s|s,沙特阿拉伯|s|s,圣诞岛|s|s,圣多美和普林西比|s|s,圣赫勒拿|s|s,圣基茨和尼维斯联邦|s|s,圣卢西亚|s|s,新加坡|x|x,斯洛文尼亚|s|s,斯威士兰|s|s,所罗门群岛|s|s,塔吉克斯坦|t|t,坦桑尼亚|t|t,汤加|t|t,图瓦卢|t|t,托克劳|t|t,危地马拉|w|w,文莱|w|w,尼泊尔|n|n,西撒哈拉|x|x,西萨摩亚|x|x,新喀里多尼亚|x|x,亚美尼亚|y|y,以色列|y|y,印度尼西亚|y|y,赞比亚|z|z,乍得|z|z,直布罗陀|z|z,中非共和国|z|z,沙特|s|s,科威特|k|k,伊拉克|y|y,也门|y|y,土耳其|t|t,叙利亚|x|x,卡塔尔|k|k,法国|f|f,菲律宾|f|f,马来西亚|m|m,巴基斯坦|b|b,斯里兰卡|s|s,马尔代夫|m|m,塞浦路斯|s|s,越南|y|y,中国澳门|z|z,中国台湾|z|z,中国香港|z|z,奥地利|a|a,瑞典|r|r,俄罗斯|e|e,荷兰|h|h,瑞士|r|r,希腊|x|x,芬兰|f|f,挪威|n|n,丹麦|d|d,西班牙|x|x,德国|d|d,葡萄牙|p|p,比利时|b|b,意大利|y|y,卢森堡|l|l,匈牙利|x|x,罗马尼亚|l|l,塞尔维亚|s|s,圣马力诺|s|s,捷克|j|j,澳大利亚|a|a,斯洛伐克|s|s,爱尔兰|a|a,波兰|b|b,冰岛|b|b,乌克兰|w|w,白俄罗斯|b|b,所罗门|s|s,新西兰|x|x,智利|z|z,利比亚|l|l,特立尼达和多巴哥|t|t,乌拉圭|w|w,墨西哥|m|m,巴拿马|b|b,阿根廷|a|a,巴拉圭|b|b,秘鲁|m|m,牙买加|y|y,多米尼加|d|d,哥伦比亚|g|g,阿联酋|a|a,委内瑞拉|w|w,厄瓜多尔|e|e,玻利维亚|b|b,哥斯达黎加|g|g,伯利兹|b|b,埃及|a|a,多哥|d|d,苏丹|s|s,帕劳|p|p,巴西|b|b,马里|m|m,加纳|j|j,苏里南|s|s,布隆迪|b|b,摩洛哥|m|m,索马里|s|s,乌干达|w|w,肯尼亚|k|k,突尼斯|t|t,卢旺达|l|l,哈萨克斯坦|h|h,土库曼斯坦|t|t,乌兹别克斯坦|w|w,尼日利亚|n|n,多米尼克|d|d,阿尔及利亚|a|a,保加利亚|b|b',
      countryYiwen: [
        ['美国', '英文'],
        ['加拿大', '法文'],
        ['加拿大', '英文'],
        ['日本', '日文'],
        ['日本', '英文'],
        ['日本', '中文'],
        ['英国', '英文'],
        ['新加坡', '马来文'],
        ['新加坡', '泰米尔文'],
        ['新加坡', '英文'],
        ['新加坡', '中文'],
        ['西班牙', '西班牙文'],
        ['西班牙', '英文'],
        ['意大利', '英文'],
        ['意大利', '意大利文'],
        ['澳大利亚', '英文'],
        ['扎伊尔', '英文'],
        ['莱索托', '英文'],
        ['几内亚', '英文'],
        ['几内亚', '法文'],
        ['安哥拉', '英文'],
        ['安哥拉', '葡萄牙文'],
        ['尼加拉瓜', '英文'],
        ['南非', '英文'],
        ['南非', '南非祖鲁语'],
        ['阿尔巴尼亚', '英文'],
        ['阿富汗', '英文'],
        ['阿鲁巴', '英文'],
        ['阿曼', '英文'],
        ['阿塞拜疆', '英文'],
        ['埃塞俄比亚', '英文'],
        ['爱沙尼亚', '英文'],
        ['安道尔', '英文'],
        ['安提瓜和巴布达', '英文'],
        ['巴巴多斯', '英文'],
        ['巴布亚新几内亚', '英文'],
        ['巴哈马', '英文'],
        ['巴林', '英文'],
        ['百慕大', '英文'],
        ['泰国', '英文'],
        ['泰国', '泰文'],
        ['贝宁', '英文'],
        ['波多黎各', '英文'],
        ['波黑', '英文'],
        ['博茨瓦纳', '英文'],
        ['不丹', '英文'],
        ['布其纳法索', '英文'],
        ['布维岛', '英文'],
        ['朝鲜', '英文'],
        ['赤道几内亚', '英文'],
        ['东帝汶', '英文'],
        ['缅甸', '英文'],
        ['多明哥', '英文'],
        ['俄罗斯联邦', '英文'],
        ['法罗群岛', '英文'],
        ['法属玻里尼西亚', '英文'],
        ['法属圭亚那', '英文'],
        ['法属南方领土', '英文'],
        ['梵蒂冈', '英文'],
        ['斐济', '英文'],
        ['佛得角', '英文'],
        ['福克兰群岛', '英文'],
        ['伊朗', '英文'],
        ['伊朗', '波斯文'],
        ['冈比亚', '英文'],
        ['刚果', '英文'],
        ['格林纳达', '英文'],
        ['格陵兰', '英文'],
        ['格鲁吉亚', '英文'],
        ['古巴', '英文'],
        ['瓜德罗普', '英文'],
        ['关岛', '英文'],
        ['圭亚那', '英文'],
        ['海地', '英文'],
        ['印度', '英文'],
        ['印度', '印地文'],
        ['洪都拉斯', '英文'],
        ['基里巴斯', '英文'],
        ['吉布提', '英文'],
        ['吉尔吉斯斯坦', '英文'],
        ['几内亚比绍', '英文'],
        ['加蓬', '英文'],
        ['柬埔寨', '英文'],
        ['津巴布韦', '英文'],
        ['喀麦隆', '英文'],
        ['约旦', '英文'],
        ['约旦', '阿拉伯文'],
        ['开曼群岛', '英文'],
        ['科摩罗', '英文'],
        ['科特迪瓦', '英文'],
        ['可可岛', '英文'],
        ['克罗地亚', '英文'],
        ['库克群岛', '英文'],
        ['拉脱维亚', '英文'],
        ['老挝', '英文'],
        ['黎巴嫩', '英文'],
        ['立陶宛', '英文'],
        ['印尼', '印尼文'],
        ['利比里亚', '英文'],
        ['列支敦士登', '英文'],
        ['马达加斯加', '英文'],
        ['马尔他', '英文'],
        ['马拉维', '英文'],
        ['马绍尔群岛', '英文'],
        ['毛里求斯', '英文'],
        ['毛里塔尼亚', '英文'],
        ['蒙古', '英文'],
        ['密克罗尼西亚', '英文'],
        ['韩国', '英文'],
        ['韩国', '韩文'],
        ['摩尔多瓦', '英文'],
        ['摩纳哥', '英文'],
        ['莫桑比克', '英文'],
        ['纳米比亚', '英文'],
        ['南极洲', '英文'],
        ['斯洛伐克', '英文'],
        ['斯洛伐克', '斯洛伐克文'],
        ['南斯拉夫', '英文'],
        ['瑙鲁', '英文'],
        ['尼日尔', '英文'],
        ['纽埃', '英文'],
        ['皮特开恩群岛', '英文'],
        ['孟加拉', '英文'],
        ['孟加拉', '孟加拉文'],
        ['萨尔瓦多', '英文'],
        ['塞拉利昂', '英文'],
        ['塞内加尔', '英文'],
        ['塞舌尔', '英文'],
        ['沙特阿拉伯', '英文'],
        ['圣诞岛', '英文'],
        ['圣多美和普林西比', '英文'],
        ['圣赫勒拿', '英文'],
        ['圣基茨和尼维斯联邦', '英文'],
        ['圣卢西亚', '英文'],
        ['斯洛文尼亚', '英文'],
        ['斯威士兰', '英文'],
        ['所罗门群岛', '英文'],
        ['塔吉克斯坦', '英文'],
        ['坦桑尼亚', '英文'],
        ['汤加', '英文'],
        ['图瓦卢', '英文'],
        ['托克劳', '英文'],
        ['危地马拉', '英文'],
        ['文莱', '英文'],
        ['尼泊尔', '英文'],
        ['西撒哈拉', '英文'],
        ['西萨摩亚', '英文'],
        ['新喀里多尼亚', '英文'],
        ['亚美尼亚', '英文'],
        ['以色列', '英文'],
        ['印度尼西亚', '英文'],
        ['赞比亚', '英文'],
        ['乍得', '英文'],
        ['直布罗陀', '英文'],
        ['中非共和国', '英文'],
        ['沙特', '英文'],
        ['沙特', '阿拉伯文'],
        ['科威特', '英文'],
        ['科威特', '阿拉伯文'],
        ['伊拉克', '英文'],
        ['伊拉克', '阿拉伯文'],
        ['也门', '英文'],
        ['土耳其', '英文'],
        ['叙利亚', '英文'],
        ['卡塔尔', '英文'],
        ['法国', '英文'],
        ['法国', '法文'],
        ['菲律宾', '英文'],
        ['菲律宾', '菲律宾文'],
        ['马来西亚', '英文'],
        ['马来西亚', '马来文'],
        ['巴基斯坦', '英文'],
        ['巴基斯坦', '乌尔都文'],
        ['斯里兰卡', '英文'],
        ['斯里兰卡', '泰米尔文'],
        ['马尔代夫', '英文'],
        ['塞浦路斯', '英文'],
        ['塞浦路斯', '土耳其文'],
        ['塞浦路斯', '希腊文'],
        ['越南', '英文'],
        ['越南', '越南文'],
        ['中国澳门', '中文'],
        ['中国澳门', '英文'],
        ['中国澳门', '葡萄牙文'],
        ['中国台湾', '中文'],
        ['中国台湾', '英文'],
        ['中国香港', '中文'],
        ['中国香港', '英文'],
        ['奥地利', '英文'],
        ['奥地利', '德文'],
        ['中国', '中文'],
        ['瑞典', '英文'],
        ['瑞典', '瑞典文'],
        ['俄罗斯', '英文'],
        ['俄罗斯', '俄文'],
        ['荷兰', '英文'],
        ['荷兰', '韩文'],
        ['荷兰', '荷兰文'],
        ['瑞士', '英文'],
        ['瑞士', '德文'],
        ['瑞士', '法文'],
        ['瑞士', '意大利文'],
        ['希腊', '英文'],
        ['希腊', '希腊文'],
        ['芬兰', '英文'],
        ['芬兰', '瑞典文'],
        ['挪威', '英文'],
        ['挪威', '挪威文'],
        ['挪威', '瑞典文'],
        ['丹麦', '英文'],
        ['丹麦', '丹麦文'],
        ['德国', '英文'],
        ['德国', '德文'],
        ['葡萄牙', '英文'],
        ['葡萄牙', '葡萄牙文'],
        ['葡萄牙', '西班牙文'],
        ['比利时', '英文'],
        ['比利时', '德文'],
        ['比利时', '法文'],
        ['比利时', '荷兰文'],
        ['卢森堡', '英文'],
        ['卢森堡', '德文'],
        ['卢森堡', '法文'],
        ['匈牙利', '英文'],
        ['匈牙利', '德文'],
        ['匈牙利', '捷克文'],
        ['匈牙利', '匈牙利文'],
        ['罗马尼亚', '英文'],
        ['罗马尼亚', '罗马尼亚文'],
        ['塞尔维亚', '塞尔维亚文'],
        ['圣马力诺', '英文'],
        ['捷克', '英文'],
        ['捷克', '捷克文'],
        ['爱尔兰', '英文'],
        ['爱尔兰', '爱尔兰文'],
        ['波兰', '英文'],
        ['波兰', '波兰文'],
        ['波兰', '德文'],
        ['冰岛', '英文'],
        ['冰岛', '冰岛文'],
        ['乌克兰', '英文'],
        ['乌克兰', '乌克兰文'],
        ['乌克兰', '俄文'],
        ['白俄罗斯', '英文'],
        ['白俄罗斯', '白俄罗斯文'],
        ['白俄罗斯', '俄文'],
        ['所罗门', '英文'],
        ['新西兰', '英文'],
        ['新西兰', '毛利文'],
        ['智利', '英文'],
        ['智利', '西班牙文'],
        ['利比亚', '英文'],
        ['利比亚', '阿拉伯文'],
        ['特立尼达和多巴哥', '英文'],
        ['乌拉圭', '英文'],
        ['墨西哥', '英文'],
        ['墨西哥', '西班牙文'],
        ['巴拿马', '英文'],
        ['巴拿马', '西班牙文'],
        ['阿根廷', '英文'],
        ['阿根廷', '西班牙文'],
        ['巴拉圭', '西班牙文'],
        ['秘鲁', '英文'],
        ['秘鲁', '西班牙文'],
        ['牙买加', '英文'],
        ['多米尼加', '英文'],
        ['多米尼加', '西班牙文'],
        ['哥伦比亚', '英文'],
        ['哥伦比亚', '西班牙文'],
        ['阿联酋', '英文'],
        ['阿联酋', '阿拉伯文'],
        ['委内瑞拉', '英文'],
        ['厄瓜多尔', '英文'],
        ['厄瓜多尔', '西班牙文'],
        ['玻利维亚', '英文'],
        ['玻利维亚', '西班牙文'],
        ['哥斯达黎加', '英文'],
        ['哥斯达黎加', '西班牙文'],
        ['伯利兹', '英文'],
        ['埃及', '英文'],
        ['埃及', '阿拉伯文'],
        ['多哥', '英文'],
        ['多哥', '法文'],
        ['苏丹', '英文'],
        ['帕劳', '英文'],
        ['巴西', '英文'],
        ['巴西', '葡萄牙文'],
        ['巴西', '西班牙文'],
        ['马里', '英文'],
        ['马里', '法文'],
        ['加纳', '英文'],
        ['苏里南', '英文'],
        ['布隆迪', '英文'],
        ['布隆迪', '法文'],
        ['摩洛哥', '英文'],
        ['摩洛哥', '法文'],
        ['摩洛哥', '西班牙文'],
        ['索马里', '英文'],
        ['乌干达', '英文'],
        ['肯尼亚', '英文'],
        ['肯尼亚', '斯瓦西里文'],
        ['突尼斯', '英文'],
        ['卢旺达', '英文'],
        ['哈萨克斯坦', '哈萨克语'],
        ['土库曼斯坦', '英文'],
        ['乌兹别克斯坦', '英文'],
        ['尼日利亚', '英文'],
        ['多米尼克', '英文'],
        ['阿尔及利亚', '阿拉伯文'],
        ['阿尔及利亚', '法文'],
        ['阿尔及利亚', '英文'],
        ['保加利亚', '英文']
      ],
      countrylist: [],
      grouphot: ['A', 'D', 'F', 'J', 'M', 'R', 'X', 'Y', 'Z'],
      group1: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
      group2: ['J', 'K', 'L', 'M', 'N', 'P'],
      group3: ['R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
      group: 'hot',
      show: false,
      alertshow: false,
      country: '',
      yiwen: '',
      none_default: '',
      yiwenlist: []
    }
  },
  watch: {
    group () {
      if (this.group === 'hot') {
        this.getCountry(this.countryHotArr)
      } else {
        this.getCountry(this.countryArr)
      }
    },
    country (val) {
      this.getYiwen(this.country)
    },
    yiwen (val = '') {
      this.$emit('input', this.country + ';' + val)
    }
  },
  mounted () {
    this.country = this.value.split(';')[0]
    this.yiwen = this.value.split(';')[1]
    this.getCountry(this.countryHotArr)
    var self = this
    document.addEventListener('click', function (e) {
      if (!self.$el.contains(e.target)) {
        self.show = false
      }
    })
  },
  methods: {
    getCountry (datagroup) {
      this.countrylist = []
      let strs = datagroup.split(',')
      for (let str of strs) {
        str = str.split('|')
        str.length = 2
        this.countrylist.push(str)
      }
    },
    getYiwen (country) {
      this.yiwenlist = []
      for (let item of this.countryYiwen) {
        if (item[0] === country) {
          this.yiwenlist.push(item[1])
        }
      }
    },
    setGroup (group) {
      this.group = group
    },
    setCountry (country) {
      this.country = country
      this.getYiwen(country)
      this.alertshow = false
      this.popupChoose = false
    },
    check () {
      if (!this.country) {
        this.alertshow = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
border-bottom-line(color = #c4c4c4)
  content ''
  position absolute
  left 0
  bottom 0
  right auto
  top auto
  height 1px
  width 100%
  background-color color
  display block
  z-index 15
  -webkit-transform-origin 50% 100%
  transform-origin 50% 100%
  -webkit-transform scaleY(0.33)
  transform scaleY(0.33)
.popup-country
  width 100vw
  min-height 100vh
  .page
    background #fff
.com-tabs
  display flex
  padding 0
  margin 0
  list-style none
  position relative
  background #fff
  &:after
    border-bottom-line()
.com-tab
  flex 2
  justify-content center
  align-items center
  padding 15px 0
  font-size 13px
  text-align center
  // border-bottom: 1px solid #ddd;
  color #808080
  cursor pointer
  &.on
    border-bottom 4px solid #2196f3
    color #2196f3
.com-country-box
  .com-head
    position relative
    z-index 100000
    background #f7f7f8
    height 44px
    display flex
    justify-content space-between
    align-items center
    padding 0 8px
    font-size 17px
    .center
      flex 1
      text-align center
      font-weight 600
    .left, .right
      min-width 60px
      display flex
      align-items center
      i
        margin-right 5px
    .right
      justify-content flex-end
    &.material
      background #2196f3
      height 56px
      .center
        font-size 20px
        color #fff
        text-align left
      a
        color #fff
      &:after
        display none
  .com-tabs-items
    padding 12px
    dl
      margin 0 0 15px
      display flex
      padding 0
      position relative
      &:after
        border-bottom-line(#c8c7cc)
      dt
        font-weight bold
        color #999
      dd
        margin-left 20px
      a
        margin 0 12px 12px 0
        display inline-block
.weui-cell__bd, .weui-cell__bd .weui-input
  color #333 !important
</style>
